// Mobile detection utility for PWA features
// Only show install prompts on mobile — desktop users don't need to "install" a PWA

/**
 * Returns true if the current device is likely a mobile phone/tablet.
 * Checks touch support + screen width + user agent.
 */
export function isMobileDevice() {
  // Check screen width first (most reliable)
  if (typeof window !== 'undefined' && window.innerWidth >= 768) return false;

  // Check touch support
  const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

  // Check user agent for mobile devices
  const isMobileUA = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
    navigator.userAgent
  );

  return hasTouch || isMobileUA;
}

/**
 * Returns true if the app is running as an installed PWA (standalone mode).
 */
export function isStandalonePWA() {
  return window.matchMedia('(display-mode: standalone)').matches;
}
